import React from 'react'

const Seventeen = () => {
    return (
        <div className='container'>
            <h1>C program to find sum of odd numbers from 1 to n</h1>
            <div className='containers'>
             <p>We have to write a program which take a input n and we have to 
                 calculate the sum of odd numbers till n.</p> <br />
                <p>Suppose if the input is 10 then odd number b/w 0-10
                    is 1 3 5 7 9  and now we have to add them all
                    1+3+5+7+9 = 25
                </p>
             </div>
             <div className='containers'>
            <b> Example</b> <br />

             <b> Input</b> <br />

             Enter a number: 10 <br />
                <b>Output</b>  <br />

                 Sum of odd numbers from 1-10: 25 <br />
             </div>
             <h3>Logic to find sum of odd numbers from 1 to n</h3>
            Step by step descriptive logic to find sum of odd numbers between 1 to n.
            <ol>
                <li>Enter a number to find sum of odd numbers from user. Store it in some variable say N.</li>
                 <li>Initialize other variable to store sum say sum = 0.</li>
                 <li>To find sum of odd numbers we must iterate through all odd numbers between 1 to n. Run a loop from 1 to N, increment 1 in each iteration. The loop structure must look similar to for(i=1; i&lt;=N; i++).</li>
                 <li>Inside the loop add sum to the current value of i i.e. sum = sum + i.</li>
                 <li>Print the final value of sum.</li>
            </ol>
            <div className='containers'>
            <code class="library">#include &lt;stdio.h&gt;</code> <br />
            int main() <br />
&#123; <br />
   <codes className='keywords'>int</codes>  i, n, sum=0; <br />

   <codes className='comment'>/* Input range to find sum of odd numbers */</codes>  <br />
   <codes className='library'> printf</codes> ("Enter upper limit: ");<br />
   <codes className='library'> scanf</codes>("%d", &n);<br />

   <codes className='comment'> /* Find the sum of all odd number */</codes> <br />
   <codes className='keywords'> for</codes>(i=1; i &lt;=n; i+=2)<br />
    &#123;<br />
        sum += i;<br />
        &#125;<br />

        <codes className='library'> printf</codes>("Sum of odd numbers = %d", sum);<br />

        <codes className='library'> return</codes> 0;<br />
    &#125;<br />

            </div>
        </div>

    )
}

export default Seventeen
